import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { BaseResponse } from 'src/types'
import { SistemaTipo } from "../../../../../types/enum/enum"
import { HttpOperacionInforme } from "../../../api/httpOperacionInforme"
import {
    OperacionCFInsert,
    schemaOperacionCFInsert,
} from '../types/dto'
import { OperacionCF, schemaOperacionCF } from '../types/types'
import { FilePutFields } from 'src/pages/sistema/api/file-fields'

export const getEndpoint = (url = '') => `operaciones/cf${url}`

export const HttpCF = {
    get: (idOperacion: number): Promise<OperacionCF> => {
        return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}`))
            .then(response => {
                const parsed = schemaOperacionCF.safeParse(response)
                if (!parsed.success) {
                    console.error('Error de validación en HttpCF.get:', parsed.error.issues)
                    
return Promise.reject(new Error('Error de validación de datos recibidos.'))
                }
                
return parsed.data
            })
            .catch(error => {
                console.error('Error de red en HttpCF.get:', error)
                
return Promise.reject('Error de comunicación con el servidor.')
            })
    },

    // post: (operacion: OperacionCFInsert): Promise<BaseResponse> => {
    //     const parsed = schemaOperacionCFInsert.safeParse(operacion)
    //     if (!parsed.success) {
    //         console.error('Error de validación en HttpCF.post:', parsed.error.issues)
    //         return Promise.reject(new Error('Los datos de la operación no son válidos.'))
    //     }

    //     return HttpAxiosRequest.post(getEndpoint(), parsed.data)
    //         .then(response => {
    //             return Promise.resolve(response)
    //         })
    //         .catch(error => {
    //             console.error('Error de red en HttpCF.post:', error)
    //             return Promise.reject('Error al intentar crear la operación.')
    //         })
    // },

    post: (operacion: OperacionCFInsert): Promise<BaseResponse> => {
        const parsed = schemaOperacionCFInsert.safeParse(operacion);
    
        if (!parsed.success) {
          console.error('Validation Error (HttpADL.post):', parsed.error.issues);
          
return Promise.reject(new Error('Validation error.'));
        }
    
        const formData = new FormData();
        formData.append('operacionInsertarJson', JSON.stringify(parsed.data));
    
        const archivo = (operacion as any)[FilePutFields.File];
        if (archivo) {
          formData.append('file', archivo);
        }
    
        return HttpAxiosRequest.post(getEndpoint(), formData)
          .then(response => {
            return Promise.resolve(response);
          })
          .catch(error => {
            console.error('Network Error (HttpADL.post):', error);
            
return Promise.reject(new Error('Error insertando operación ADL.'));
          });
      },

    descargarInforme: (idOperacion: number): Promise<any> =>
        HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.CF),

} as const